/**
 * Endereco de cobranca que a Pagar.me exige para cobrar o cartao.
 *
 * Mesma regra do backend (PagarmeBillingAddress.cs): CEP com 8 digitos, rua,
 * cidade e UF reconhecivel. Numero, complemento e bairro vao junto quando
 * existem, mas nao sao exigidos. Sem os quatro, a Pagar.me recusa a cobranca
 * com "validation_error | billing" — por isso o webapp pede o endereco ANTES,
 * em vez de deixar o usuario descobrir pela recusa.
 */

const UF_BY_NAME: Record<string, string> = {
  acre: "AC",
  alagoas: "AL",
  amapa: "AP",
  amazonas: "AM",
  bahia: "BA",
  ceara: "CE",
  "distrito federal": "DF",
  "federal district": "DF",
  "espirito santo": "ES",
  goias: "GO",
  maranhao: "MA",
  "mato grosso": "MT",
  "mato grosso do sul": "MS",
  "minas gerais": "MG",
  para: "PA",
  paraiba: "PB",
  parana: "PR",
  pernambuco: "PE",
  piaui: "PI",
  "rio de janeiro": "RJ",
  "rio grande do norte": "RN",
  "rio grande do sul": "RS",
  rondonia: "RO",
  roraima: "RR",
  "santa catarina": "SC",
  "sao paulo": "SP",
  sergipe: "SE",
  tocantins: "TO",
};

export const VALID_UFS = Array.from(new Set(Object.values(UF_BY_NAME))).sort();

const removeAccents = (value: string) =>
  value.normalize("NFD").replace(/[̀-ͯ]/g, "");

/**
 * Sigla da UF a partir do que esta no cadastro, que vem misturado ("SP",
 * "Sao Paulo", "State of Sao Paulo"). Nulo quando nao reconhece.
 */
export const toUf = (state?: string | null): string | null => {
  let key = removeAccents((state || "").trim()).toLowerCase();
  if (!key) return null;

  for (const prefix of ["state of ", "estado de ", "estado do ", "estado da "]) {
    if (key.startsWith(prefix)) key = key.substring(prefix.length).trim();
  }

  if (key.length === 2) {
    const upper = key.toUpperCase();
    return VALID_UFS.includes(upper) ? upper : null;
  }

  return UF_BY_NAME[key] ?? null;
};

export const onlyDigits = (value?: string | null) =>
  (value || "").replace(/\D/g, "");

/** O perfil (GET /userprofile) tem endereco de cobranca completo? */
export const hasBillingAddress = (user: any): boolean =>
  !!user &&
  onlyDigits(user.cep).length === 8 &&
  !!(user.address || "").trim() &&
  !!(user.city || "").trim() &&
  !!toUf(user.state);
